import { render, staticRenderFns } from "./LoginTemplate.vue?vue&type=template&id=007c3a81&scoped=true"
import script from "./LoginTemplate.vue?vue&type=script&lang=ts"
export * from "./LoginTemplate.vue?vue&type=script&lang=ts"
import style0 from "./LoginTemplate.vue?vue&type=style&index=0&id=007c3a81&scoped=true&lang=css"
import style1 from "./LoginTemplate.vue?vue&type=style&index=1&id=007c3a81&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007c3a81",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\808325\\Documents\\SsmlockEntryReqWebApp-IVC202512\\SsmlockEntryReqWebApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('007c3a81')) {
      api.createRecord('007c3a81', component.options)
    } else {
      api.reload('007c3a81', component.options)
    }
    module.hot.accept("./LoginTemplate.vue?vue&type=template&id=007c3a81&scoped=true", function () {
      api.rerender('007c3a81', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/LoginTemplate/LoginTemplate.vue"
export default component.exports